export default "__VITE_ASSET__Dc_gPJjv__"